(() => {
 function setup(root) {
  const body = document.querySelector('#BfMessage');
  const vehicle = new URLSearchParams(location.search).get('vehicle');
  const service = new URLSearchParams(location.search).get('service');
  if(body&&!body.value&&service)body.value='【ご相談内容】'+service+'\n\n';
  if (body && !body.value && vehicle) body.value = '【お問い合わせ車両】'+vehicle+'\n\n';
 }
 setup(document);document.addEventListener('shopify:section:load', event=>setup(event.target));
})();
(() => {
 function move(button){
  const section=button.closest('.bf-catalog');
  const row=section?.querySelector('.bf-home-products:not([hidden])>.bf-grid');
  if(!row)return;
  const card=row.querySelector('.bf-card');
  const gap=parseFloat(getComputedStyle(row).columnGap)||0;
  const distance=card?card.getBoundingClientRect().width+gap:row.clientWidth;
  row.scrollBy({left:Number(button.dataset.bfScroll)*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 }
 document.addEventListener('click',event=>{const button=event.target.closest('[data-bf-scroll]');if(button)move(button)});
 document.addEventListener('keydown',event=>{
  if(event.target.matches('.bf-home-products[tabindex]')&&(event.key==='ArrowLeft'||event.key==='ArrowRight')){
   const button=event.target.closest('.bf-catalog').querySelector('[data-bf-scroll="'+(event.key==='ArrowLeft'?'-1':'1')+'"]');
   if(button){event.preventDefault();move(button)}
  }
 });
})();

(() => {
 function activate(tab,focus=false){
  const section=tab.closest('[data-bf-motorcycle-home]');if(!section)return;
  section.querySelectorAll('[data-bf-motorcycle-tab]').forEach(item=>{
   const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;
   const panel=section.querySelector('#'+CSS.escape(item.getAttribute('aria-controls')));if(panel)panel.hidden=!selected;
  });
  section.querySelectorAll('[data-bf-motorcycle-all]').forEach(link=>link.href=tab.dataset.url);
  if(focus)tab.focus();
 }
 document.addEventListener('click',event=>{const tab=event.target.closest('[data-bf-motorcycle-tab]');if(tab)activate(tab)});
 document.addEventListener('keydown',event=>{
  const tab=event.target.closest('[data-bf-motorcycle-tab]');if(!tab)return;
  const tabs=[...tab.closest('[role=tablist]').querySelectorAll('[role=tab]')];let index=tabs.indexOf(tab);
  if(event.key==='ArrowRight')index=(index+1)%tabs.length;else if(event.key==='ArrowLeft')index=(index-1+tabs.length)%tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=tabs.length-1;else return;
  event.preventDefault();activate(tabs[index],true);
 });
})();
(() => {
 function updateHeader(){document.querySelectorAll('.bf-site-header--home').forEach(header=>header.classList.toggle('is-scrolled',window.scrollY>0))}
 updateHeader();window.addEventListener('scroll',updateHeader,{passive:true});window.addEventListener('pageshow',updateHeader);document.addEventListener('shopify:section:load',updateHeader);
})();

(() => {
 function setup(root){root.querySelectorAll('.bf-drawer').forEach(dialog=>{
  if(dialog.dataset.bfReady)return;dialog.dataset.bfReady='true';
  const trigger=document.querySelector('[aria-controls="'+dialog.id+'"]');if(!trigger)return;
  let closing=false,timer;
  function finish(){clearTimeout(timer);dialog.classList.remove('is-visible');dialog.close();closing=false;trigger.setAttribute('aria-expanded','false');document.documentElement.classList.remove('bf-drawer-open');trigger.focus({preventScroll:true})}
  function close(){if(!dialog.open||closing)return;closing=true;dialog.classList.remove('is-visible');trigger.setAttribute('aria-expanded','false');if(matchMedia('(prefers-reduced-motion: reduce)').matches)finish();else timer=setTimeout(finish,380)}
  trigger.addEventListener('click',()=>{if(dialog.open){close();return}dialog.showModal();document.documentElement.classList.add('bf-drawer-open');trigger.setAttribute('aria-expanded','true');requestAnimationFrame(()=>requestAnimationFrame(()=>{if(dialog.open&&!closing)dialog.classList.add('is-visible')}))});
  dialog.querySelector('.bf-drawer-close').addEventListener('click',close);
  dialog.addEventListener('cancel',e=>{e.preventDefault();close()});
  dialog.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{clearTimeout(timer);dialog.classList.remove('is-visible');dialog.close();closing=false;trigger.setAttribute('aria-expanded','false');document.documentElement.classList.remove('bf-drawer-open')}));
  const desktop=matchMedia('(min-width:900px)');desktop.addEventListener('change',e=>{if(e.matches&&dialog.open)finish()});
  dialog.addEventListener('close',()=>{document.documentElement.classList.remove('bf-drawer-open');trigger.setAttribute('aria-expanded','false')});
 })}
 setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target));document.addEventListener('shopify:section:unload',()=>document.documentElement.classList.remove('bf-drawer-open'));
})();
